import { VALIDATE_TOKEN, VALIDATE_TOKEN_FAILURE, VALIDATE_TOKEN_REQUEST, VALIDATE_TOKEN_SUCCESS } from "./actionTypes"

export const validateToken = (data) => {
    return {
        type: VALIDATE_TOKEN,
        payload: { ...data }
    }
}

export const validateTokenRequest = () => {
    return {
        type: VALIDATE_TOKEN_REQUEST
    }
}

export const validateTokenSuccess = data => {
    return {
        type: VALIDATE_TOKEN_SUCCESS,
        payload: data,
    }
}

export const validateTokenFailure = error => {
    return {
        type: VALIDATE_TOKEN_FAILURE,
        payload: error,
    }
}